import { initializeApp, getApps } from 'firebase/app';
import { getMessaging, isSupported } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyBkLKT8InlgoF5iL_RbLcYjTlNkAnDxuFA",
  authDomain: "bip-manager.firebaseapp.com",
  projectId: "bip-manager",
  storageBucket: "bip-manager.firebasestorage.app",
  messagingSenderId: "1010893284877",
  appId: "1:1010893284877:web:e67bf2ed412b100ea19744"
};

// Évite d'initialiser deux fois
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

// getMessaging() peut lever une exception sur iOS/Safari si Web Push n'est pas supporté
// On l'exporte comme null-safe pour éviter un crash silencieux du module
let messagingInstance: ReturnType<typeof getMessaging> | null = null;
try {
  messagingInstance = getMessaging(app);
} catch (e) {
  console.warn('[Firebase] getMessaging() non supporté sur ce navigateur:', e);
}

export const messaging = messagingInstance;
export const VAPID_KEY = "BNTUz9FJt-nYXodzHuF2siInSpmaHKNyoWVGcQiY0Osx7DrSJDEAcdth2JNv2ldluRsE2CaM3NiWHe6xI_OJp-w";

// Helper async pour vérifier si le navigateur supporte réellement Firebase Messaging
export const isFCMSupported = () => isSupported().catch(() => false);
